<template>
  <div class="payment-summary-page">
    <div class="payment-summary-container">
      <div class="payment-summary-title">สรุปยอดการชำระเงิน</div>
      <div class="payment-summary-information-container">
        <div
          class="payment-information"
          v-for="insuredInformation in insuredInformationList"
          :key="insuredInformation.id"
        >
          <div class="insured-information-section">
            <div class="title">ผู้เอาประกันภัย</div>
            <div class="description">
              {{ insuredInformation.namePrefix }} {{ insuredInformation.firstname }}
              {{ insuredInformation.lastname }}
            </div>
          </div>

          <div class="package-price-information-section">
            <div class="title">
              ค่าเบี้ยสุทธิ ({{ insuredInformation.planPackageScheme.coverageCode }})
            </div>
            <div class="description">
              {{ insuredInformation.planPackageScheme.grossPremium | formatNumber }} บาท
            </div>
          </div>

          <div class="deductible-information-section">
            <div class="title">
              ส่วนลดเบี้ยประกันภัยสำหรับการติดเงื่อนไขความรับผิดส่วนแรก (Deductible-DD)
              สำหรับค่าห้องและค่ารักษาพยาบาลผู้ป่วยใน (DD{{
                insuredInformation.deductible.deduct | formatNumber
              }})
            </div>
            <div class="description">
              -{{ insuredInformation.deductible.discount | formatNumber }} บาท
            </div>
          </div>

          <div class="total-insured-price-information-section">
            <div class="title">
              ค่าเบี้ยประกันภัย
            </div>
            <div class="description">
              {{
                insuredInformation.planPackageScheme.grossPremiumAfterDeductDiscount | formatNumber
              }}
              บาท
            </div>
          </div>
        </div>
      </div>

      <div class="payment-summary-total-container">
        <div class="payer-information-section">
          <div class="title">
            ผู้ชำระเบี้ยประกันภัย
          </div>
          <div class="description">
            {{ payerInformation.namePrefix }} {{ payerInformation.firstname }}
            {{ payerInformation.lastname }}
          </div>
        </div>
        <div class="total-price-section" v-if="isHasFamilyDiscount">
          <div class="title">
            เบี้ยประกันภัยรวม
          </div>
          <div class="description">{{ paymentSummary.totalGrossPremium | formatNumber }} บาท</div>
        </div>
        <div class="discount-family-section" v-if="isHasFamilyDiscount">
          <div class="title">
            ส่วนลดเบี้ยประกันภัยสำหรับครอบครัว (ได้รับส่วนลด {{ familyQuotation.discount }}%)
          </div>
          <div class="description">
            -{{ paymentSummary.totalFamilyDiscount | formatNumber }} บาท
          </div>
        </div>
        <div class="final-total-price-section">
          <div class="title">
            รวมเบี้ยประกันภัยที่ต้องชำระ
          </div>
          <div class="description">{{ paymentSummary.totalNetPremium | formatNumber }} บาท</div>
        </div>
      </div>
      <div class="payment-summary-btn-container">
        <Button @click.native="proceedToCheckout">ชำระเบี้ยประกันภัย</Button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import Button from '@/components/Button'
import payment from '../store/payment'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

export default {
  name: 'PaymentSummary',
  props: ['application_id'],
  data: () => ({
    insuredInformationList: [],
    familyQuotation: {
      discount: null,
    },
    payerInformation: {
      id: '',
      namePrefix: '',
      firstname: '',
      lastname: '',
    },
    paymentSummary: {
      familyDiscount: 0,
      totalPrice: 0,
      finalTotalPrice: 0,
    },
    isHasFamilyDiscount: false,
  }),
  components: {
    Button,
  },
  computed: {
    ...mapApplicationFields({
      applicationInformation: 'data.applicationInformation',
    }),
  },
  watch: {
    applicationInformation: {
      handler() {
        const isFamilyType = _.get(this.applicationInformation, 'familyQuotation', null)
        const familyDiscount = _.get(this.applicationInformation, 'familyQuotation.discount', 0)
        const isCombinePayment = _.get(
          this.applicationInformation,
          'familyQuotation.isCombinePayment',
          false,
        )
        const payerId = _.get(this.applicationInformation, 'payer.personId', '')
        const payerNamePrefix = _.get(this.applicationInformation, 'payer.title.name', '')
        const payerFirstname = _.get(this.applicationInformation, 'payer.firstname', '')
        const payerLastname = _.get(this.applicationInformation, 'payer.lastname', '')

        if (isCombinePayment) {
          const familyQuotations = _.get(
            this.applicationInformation,
            'familyQuotation.quotations',
            [],
          )

          this.insuredInformationList = _.map(familyQuotations, data => ({
            id: data.applicationId,
            namePrefix: data.insuredNamePrefix,
            firstname: data.insuredFirstname,
            lastname: data.insuredLastname,
            planPackageScheme: {
              coverageCode: data.coverageCode,
              grossPremium: data.pricing.grossPremium,
              grossPremiumAfterDeductDiscount: data.pricing.grossPremiumAfterDeductDiscount,
              familyDiscount: data.pricing.familyDiscount,
              netPremium: data.pricing.netPremium,
            },
            deductible: {
              deduct: data.deductibleAmount,
              discount: data.deductDiscount,
            },
          }))
        } else {
          const applicationId = _.get(this.applicationInformation, 'applicationId', '')
          const insuredPersonId = _.get(this.applicationInformation, 'insuredPerson.personId', '')
          const insuredPersonNamePrefix = _.get(
            this.applicationInformation,
            'insuredPerson.title.name',
            '',
          )
          const insuredPersonFirstname = _.get(
            this.applicationInformation,
            'insuredPerson.firstname',
            '',
          )
          const insuredPersonLastname = _.get(
            this.applicationInformation,
            'insuredPerson.lastname',
            '',
          )
          const coverageCode = _.get(
            this.applicationInformation,
            'planPackageScheme.coverageCode',
            '',
          )
          const grossPremium = _.get(this.applicationInformation, 'pricing.grossPremium', 0)
          const grossPremiumAfterDeductDiscount = _.get(
            this.applicationInformation,
            'pricing.grossPremiumAfterDeductDiscount',
            0,
          )
          const familyDiscount = _.get(this.applicationInformation, 'pricing.familyDiscount', 0)
          const netPremium = _.get(this.applicationInformation, 'pricing.netPremium', 0)
          const deductibleDeduct = _.get(this.applicationInformation, 'deductible.deduct', 0)
          const deductibleDiscount = _.get(this.applicationInformation, 'deductible.discount', 0)

          this.insuredInformationList = [
            {
              id: applicationId,
              namePrefix: insuredPersonNamePrefix,
              firstname: insuredPersonFirstname,
              lastname: insuredPersonLastname,
              planPackageScheme: {
                coverageCode,
                grossPremium,
                grossPremiumAfterDeductDiscount,
                familyDiscount,
                netPremium,
              },
              deductible: {
                deduct: deductibleDeduct,
                discount: deductibleDiscount,
              },
            },
          ]
        }

        this.familyQuotation.discount = isFamilyType ? familyDiscount : 0
        this.payerInformation = {
          id: payerId,
          namePrefix: payerNamePrefix,
          firstname: payerFirstname,
          lastname: payerLastname,
        }
        this.isHasFamilyDiscount = Boolean(isFamilyType)

        this.$nextTick(() => {
          const totalGrossPremium = _.reduce(
            this.insuredInformationList,
            (total, data) => total + data.planPackageScheme.grossPremiumAfterDeductDiscount,
            0,
          )
          const totalFamilyDiscount = _.reduce(
            this.insuredInformationList,
            (total, data) => total + data.planPackageScheme.familyDiscount,
            0,
          )
          const totalNetPremium = _.reduce(
            this.insuredInformationList,
            (total, data) => total + data.planPackageScheme.netPremium,
            0,
          )

          this.paymentSummary = {
            totalGrossPremium,
            totalFamilyDiscount,
            totalNetPremium,
          }
        })
      },
      deep: true,
    },
  },
  mounted() {
    this.getApplicationInformation(this.application_id)
  },
  methods: {
    ...mapActions(['getApplicationInformation']),
    proceedToCheckout() {
      const isPaidByInsuredPerson = _.get(
        this.applicationInformation,
        'quotation.isPaidByInsuredPerson',
        false,
      )
      const isCombinePayment = _.get(
        this.applicationInformation,
        'familyQuotation.isCombinePayment',
        false,
      )
      const paymentType = _.get(this.applicationInformation, 'payment.paymentType', null)

      if (!isCombinePayment && isPaidByInsuredPerson) {
        if (paymentType === 'Bill Payment') {
          return this.$router.push(`/payment/bill-payment/${this.application_id}`)
        }

        if (paymentType === 'TMB Bank Account') {
          return this.$router.push(`/payment/direct-debit/success/${this.application_id}`)
        }

        if (paymentType === 'Credit Card') {
          return this.$router.push(`/payment/credit-card/${this.application_id}`)
        }

        if (paymentType === 'QR Payment') {
          return this.$router.push(`/payment/qrcode/${this.application_id}`)
        }

        return this.$swal({
          type: 'error',
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
        })
      }

      return this.$router.push(`/consent/payer/${this.application_id}`)
    },
  },
}
</script>

<style lang="scss">
.payment-summary-page {
  font-size: 14px;
  line-height: 18px;
  padding-top: 48px;

  .payment-summary-container {
    background-color: #fff;
    margin: 0 auto;
    padding: 32px;
    width: 95%;

    .payment-summary-title {
      font-family: 'psl_kanda_extraregular';
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 24px;
      text-align: center;
    }

    .payment-summary-information-container {
      .payment-information {
        border-bottom: 1px dashed #ccc;
        margin-bottom: 24px;
        padding-bottom: 24px;

        .insured-information-section,
        .package-price-information-section,
        .deductible-information-section,
        .total-insured-price-information-section {
          display: grid;
          grid-template-columns: 3fr 1fr;
          margin-bottom: 12px;
          padding: 0 12px;

          .description {
            font-family: 'psl_kanda_extraregular';
            text-align: right;
          }
        }

        .deductible-information-section {
          .description {
            color: #e40000;
          }
        }

        .total-insured-price-information-section {
          .description {
            color: #27ae60;
          }
        }
      }
    }

    .payment-summary-total-container {
      background-color: #efefef;
      border-radius: 3px;
      margin-bottom: 24px;
      padding: 32px 24px;

      .payer-information-section,
      .total-price-section,
      .discount-family-section,
      .final-total-price-section {
        display: grid;
        grid-template-columns: 3fr 1fr;
        margin-bottom: 12px;

        .description {
          font-family: 'psl_kanda_extraregular';
          text-align: right;
        }
      }

      .discount-family-section {
        .description {
          color: #e40000;
        }
      }

      .final-total-price-section {
        font-family: 'psl_kanda_extraregular';
        font-size: 18px;
        line-height: 22px;

        .description {
          color: #27ae60;
        }
      }
    }

    .payment-summary-btn-container {
      text-align: center;
    }
  }
}
</style>
